import $ from 'jquery';
import {TweenMax, TimelineMax} from 'gsap';
import {} from 'ScrollToPlugin';
import {} from 'animation.gsap';
import * as ScrollMagic from 'ScrollMagic';
import Modernizr from 'modernizr';

// load css
import {} from '../less/main.less';


$(function() {

    // get current window height
    let vh = $(window).height();
    $(window).resize(function () {
        vh = $(window).height();
    });

    // disable scroll events on mobile plattforms (way to slow)
    const isMobile = Modernizr.touchevents;
    if (!isMobile) {

        // move to initial position of scroll events are enabled
        $('.scrollable').addClass('scrollStart');

        // initialize scrollorama
        const controller = new ScrollMagic.Controller({
            globalSceneOptions: {
                triggerHook: 0
            }
        });

        // scroll animations 'home'
        const background = $('.background');
        const homeTimeline = new TimelineMax()
            .to(background, 1, {css: {top: '50px'}}, 0)
            .to(background, 1, {css: {left: '5%'}}, 0)
            .to(background, 1, {width: '10%'}, 0)
            .to('#headline', 1, {css: {left: '100%'}}, 0)
            .to('#home .panel', 1, {css: {left: '100%'}}, 0);
        const homeScene = new ScrollMagic.Scene({
            triggerElement: '#home',
            triggerHook: 'onEnter',
            duration: vh,
        }).setTween(homeTimeline);

        // scroll animations 'contact'
        const contactTimeline = new TimelineMax()
            .to('#contact .content', vh / 2, {css: {opacity: 1}}, vh / 2)
            .to('.nextSlide', vh / 10, {css: {opacity: 0}}, 0);
        const contactScene = new ScrollMagic.Scene({
            triggerElement: '#contact',
            duration: vh / 2,
            offset: -3 * vh / 4
        }).setTween(contactTimeline);

        // setup scroll controller
        controller.addScene([
            homeScene,
            contactScene
        ]);

        // update next slide button with next slide
        $(window).scroll(function () {
            const scrollPos = $(window).scrollTop();
            if (scrollPos < vh) {
                $('.nextSlide a').attr('href', '#contact');
            }
        });
        $('#homeLink').click(function () {
            $('.nextSlide a').attr('href', '#contact');
        });

        $(document).on('click', 'a[href^="#"]', function (evt) {
            const slideId = $(this).attr("href");
            if ($(slideId).length > 0) {
                evt.preventDefault();

                // trigger scroll
                TweenMax.to(window, 2, {
                    scrollTo: slideId,
                    ease:Power2.easeOut
                });
            }
        });
    }

    // show body
    $('body').removeClass('hidden');

});



// WEBPACK FOOTER //
// ./src/js/main.js